import React, { Component } from 'react';
import './LabelAndValue.css';
import Label from '../../components/label/Label';

export default class LabelAndValue extends Component {
	render() {
		return (
			<div className={'g-label-and-value ' + (this.props.className || '')}>
				<Label className="label" black bold>
					{this.props.label}
				</Label>
				<Label className="value" black>
					{this.props.value || '-'}
				</Label>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/labelAndValue/LabelAndValue.jsx